module.exports = __webpack_public_path__ + "static/media/avon_logo_footer.3c4c03e8.svg";